var render, staticRenderFns
import script from "./AssignmentDialog.vue?vue&type=script&lang=js&"
export * from "./AssignmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\el-dynamic-form-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e06125')) {
      api.createRecord('61e06125', component.options)
    } else {
      api.reload('61e06125', component.options)
    }
    
  }
}
component.options.__file = "src/render/AssignmentDialog.vue"
export default component.exports